"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputStyled = exports.SelectStyled = exports.MaskInputStyled = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const antd_mask_input_1 = __importDefault(require("antd-mask-input"));
const antd_1 = require("antd");
exports.MaskInputStyled = (0, styled_components_1.default)(antd_mask_input_1.default) `
  border-radius: 5px;
  height: 43px;
`;
exports.SelectStyled = (0, styled_components_1.default)(antd_1.Select) `
  .ant-select-selector {
    border-radius: 5px !important;
    height: 43px !important;
    min-width: 80px !important;
  }
`;
exports.InputStyled = (0, styled_components_1.default)(antd_1.Input) `
  border-radius: 5px;
  height: 43px;

  &[type='number']::-webkit-inner-spin-button,
  &[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none !important;
    margin: 0 !important;
  }
`;
